module.exports = __webpack_public_path__ + "img/PeopleOut.636e6316.svg";